/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFlipHorizontal = createReactComponent("flip-horizontal", "IconFlipHorizontal", [
  ["path", { d: "M3 12l18 0", key: "svg-0" }],
  ["path", { d: "M7 16l10 0l-10 5l0 -5", key: "svg-1" }],
  ["path", { d: "M7 8l10 0l-10 -5l0 5", key: "svg-2" }]
]);

export { IconFlipHorizontal as default };
//# sourceMappingURL=IconFlipHorizontal.js.map
